import { render, staticRenderFns } from "./CampaignDetail.vue?vue&type=template&id=18248041&scoped=true"
import script from "./CampaignDetail.vue?vue&type=script&lang=js"
export * from "./CampaignDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/main.css?vue&type=style&index=0&id=18248041&prod&scoped=true&lang=css&external"
import style1 from "./CampaignDetail.vue?vue&type=style&index=1&id=18248041&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18248041",
  null
  
)

export default component.exports